<template>
<!-- 冰柜领用订单的明细显示可能会有不同的地方，可以考虑单独做一个组件或者增加一个prop传递参数用于区别展示 -->
  <el-table :data="detailList" :show-header="false" class="order-detail">
    <el-table-column label="图片" width="100">
      <template slot-scope="scope">
        <div class="item-image">
          <img :src="getImageUrl(scope.row.pocmDTO)" />
        </div>
      </template>
    </el-table-column>
    <el-table-column label="名称" width="250">
      <template slot-scope="scope">
        <div class="item-name">{{ scope.row.itemName }}</div>
      </template>
    </el-table-column>
    <el-table-column label="品牌" width="200">
      <template slot-scope="scope">
        <div>{{ scope.row.pocmDTO.itemBrandList[0].abiBrandName }}</div>
      </template>
    </el-table-column>
    <el-table-column label="分类" width="200">
      <template slot-scope="scope">
        <div>{{ scope.row.pocmDTO.itemCategory.categoryName }}</div>
      </template>
    </el-table-column>
    <el-table-column label="状态" width="240">
      <template slot-scope="scope">
        状态: {{ scope.row.detailStatusName }}
      </template>
    </el-table-column>
    <el-table-column label="数量">
      <template slot-scope="scope">
        数量: {{ scope.row.itemQuantity }}
      </template>
    </el-table-column>
    <el-table-column label="小计">
      <template slot-scope="scope">
        <div class="item-sum">小计: {{ getItemSumPrice(scope.row) }}</div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { commonUtils } from '@/utils/common'
import { create, all } from 'mathjs/number'
const math = create(all)
export default {
  name: 'order-line-detail',
  props: {
    detailList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    getItemSumPrice (item) {
      if (!item) {
        return ''
      }
      return commonUtils.formatNumber(
        math.multiply(item.itemPrice, item.itemQuantity)
      ).toFixed(2)
    },
    getImageUrl (item) {
      let imageUri = ''
      if (item.imageList && item.imageList.length > 0) {
        imageUri = item.imageList[0].imageFileUri
      }
      return commonUtils.getImageUrl(imageUri)
    }
  }
}
</script>

<style lang="scss" scoped>
.order-detail {
  .item-image {
    width: 72px;
    height: 72px;
    margin: 0 auto;
    border: 1px solid $base-grey;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    img {
      max-width: 90%;
      max-height: 90%;
    }
  }

  .item-name {
    text-align: left;
    font-weight: 700;
  }

  .item-sum {
    font-weight: 700;
  }
}
</style>
